import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import FormTurnos from "../FormTurnos/FormTurnos";
import "./CadastroTurnos.css";
import ShiftService from "../../../services/ShiftService";
import { parseShift } from "../ListTurnos/ListTurnos";

const CadastroTurnos = () => {
	const { shiftId } = useParams();
	const { state } = useLocation();
	const [type, setType] = useState("");
	const [turno, setTurno] = useState(state);

	async function loadTurno(id) {
		const response = await ShiftService.getShift(id);
		if (response.data) {
			setTurno(parseShift(response.data));
		}
	}

	useEffect(() => {
		setType(shiftId || state ? "edicao" : "cadastro");

		if (turno) {
			setTurno(state);
			return;
		}

		if (shiftId) {
			loadTurno(shiftId);
		}
	}, [state, shiftId]);

	return (
		<CadastroContainer>
			<FormTurnos turno={turno} type={type} />
		</CadastroContainer>
	);
};

export default CadastroTurnos;
